const routes = [{
  path: '/coupon/:courseIds',
  load: () => import(/* webpackChunkName: 'couponserial' */ './coupon'),
}, {
  path: '/:id',
  load: () => import(/* webpackChunkName: 'serialcourse' */ './serial'),
}]

export default routes



// WEBPACK FOOTER //
// ./src/routes/serial/index.js